import { useState, useContext } from "react";
import "./menubar.css";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";

const Menubar = () => {
  const { t } = useContext(LanguageContext);

  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState("Home");
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleMenuClick = (item) => {
    setActiveItem(item);
    setIsOpen(false);

    const route = item.toLowerCase().replace(/\s+/g, "");
    navigate(route === "home" ? "/" : `/${route}`);
  };

  const menuKeys = ["Home", "Category", "Blog", "AboutUs", "ContactUs"];

  return (
    <nav className="main-navbar">
      <div className="hamburger" onClick={toggleMenu}>
        &#9776;
      </div>

      <div className="nav-menu-container">
        <ul className={`nav-menu contact-item ${isOpen ? "open" : ""}`}>
          {menuKeys.map((item) => (
            <li
              key={item}
              className={activeItem === item ? "active" : ""}
              onClick={() => handleMenuClick(item)}
            >
              {t(`navbar.menu.${item}`)}
            </li>
          ))}
        </ul>
      </div>

      {isOpen && (
        <div className="close-btn" onClick={toggleMenu}>
          &times;
        </div>
      )}
    </nav>
  );
};

export default Menubar;
